import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'core-helpers-forms-button-icon',
  templateUrl: './button-icon.component.html',
  styleUrls: ['./button-icon.component.scss'],
})
/**
    icon:  
    add --> icon with a plus 
    edit --> edit
    edit-tags --> edit-tags
    upload --> upload
    send --> send
    feedback --> feedback
    open-message-link --> open-message-link
    open-link --> open-link
    download --> download
    calendar --> calendar blue
    calendar-back --> calendar black
    green-clock --> green-clock
    red-clock --> red-clock
    orange-clock --> orange-clock
*/
export class ButtonIconComponent {

    @Input() disabled:any = false;
    @Input() text:any;
    @Input() icon:string;
    @Output() submit = new EventEmitter<any>();

    sendParent(){
        this.submit.emit(true);
    }
}
